import { Button, Link, Notice, Table, Text } from "@smooth/design-system-components"
import NextLink from "next/link"
import { useRouter } from "next/router"
import { useReconciliations } from "../hooks/useReconciliations"
import Pagination from "src/components/tailwind-components/Pagination"
import { formatDateTime } from "src/features/admin/screen-shared"

const COLUMNS = [
  { key: "id", header: "Id" },
  { key: "payment", header: "Payment" },
  { key: "paymentPromise", header: "Payment Promise" },
  { key: "invoiceable", header: "Invoiceable" },
  { key: "amount", header: "Amount" },
  { key: "paymentAt", header: "支払日" },
  { key: "userId", header: "ユーザーID" },
  { key: "userName", header: "ユーザー名" },
  { key: "paymentMethod", header: "支払方法" },
]

/** 消込の一覧。admin と同じ列を ID の新しい順に出す。検索は無い（admin の検索欄は何も絞り込まないため） */
export const ReconciliationList = ({ page }: { page: number }) => {
  const router = useRouter()
  const { reconciliations, pagination, error, isLoading } = useReconciliations(page)

  if (error) return <Notice tone="error">一覧を取得できませんでした</Notice>
  if (isLoading) return <Text>読み込み中...</Text>

  const rows = reconciliations.map((reconciliation) => ({
    id:
      reconciliation.id === null ? null : (
        <Link href={`/admin/reconciliations/${reconciliation.id}`}>{reconciliation.id}</Link>
      ),
    payment:
      reconciliation.paymentId === null ? null : (
        <Link href={`/admin/payments/${reconciliation.paymentId}`}>{reconciliation.paymentId}</Link>
      ),
    paymentPromise:
      reconciliation.paymentPromiseId === null ? null : (
        <Link href={`/admin/payment-promises/${reconciliation.paymentPromiseId}`}>
          {reconciliation.paymentPromiseId}
        </Link>
      ),
    invoiceable: `${reconciliation.invoiceableType} #${reconciliation.invoiceableId ?? ""}`,
    amount: reconciliation.amount,
    paymentAt: formatDateTime(reconciliation.paymentAt),
    userId:
      reconciliation.userId === null ? null : (
        <Link href={`/admin/users/${reconciliation.userId}`}>{reconciliation.userId}</Link>
      ),
    userName: reconciliation.userName,
    paymentMethod: reconciliation.paymentableType ?? "",
  }))

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2">
        <Button asChild>
          <NextLink href="/admin/reconciliations/new">新規作成</NextLink>
        </Button>
        <Button asChild variant="outline">
          <NextLink href="/admin/reconciliations/manual">手動消込</NextLink>
        </Button>
      </div>
      <Table
        columns={COLUMNS}
        rows={rows}
        onRowClick={(index) => router.push(`/admin/reconciliations/${reconciliations[index].id}`)}
      />
      <Pagination
        pagination={{
          currentPage: page,
          totalPages: pagination?.totalPages ?? 1,
          totalCount: pagination?.totalCount ?? 0,
        }}
        onPageChange={(next) => router.push({ query: { ...router.query, page: next } })}
      />
    </div>
  )
}
